import { render } from "./PageMenu.vue?vue&type=template&id=968db954"
import script from "./PageMenu.vue?vue&type=script&lang=js"
export * from "./PageMenu.vue?vue&type=script&lang=js"

import "./PageMenu.vue?vue&type=style&index=0&id=968db954&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__